import { lazy } from "react";
import { ERouteMappingKeys } from "./routeKeys";

export const specialDevicesRoutes = {
  [ERouteMappingKeys.SPECIAL_DEVICES]: {
    id: "special-devices",
    // @TODO double check this new route or add redirect
    path: "/camera-security/special-devices",
    components: {
      "compact-cameras": lazy(() =>
        import("pages/Sections/CameraSecurity/SpecialDevices").then((p) => ({
          default: p.SpecialDevices,
        })),
      ),
      "super-link": lazy(() =>
        import("pages/Sections/CameraSecurity/SpecialDevices/SuperLink").then(
          (p) => ({ default: p.SuperLink }),
        ),
      ),
      "ai-enhancements": lazy(() =>
        import(
          "pages/Sections/CameraSecurity/SpecialDevices/AIEnhancements"
        ).then((p) => ({ default: p.AIEnhancements })),
      ),
      floodlight: lazy(() =>
        import("pages/Sections/CameraSecurity/SpecialDevices/Floodlight").then(
          (p) => ({ default: p.Floodlight }),
        ),
      ),
      doorbells: lazy(() =>
        import("pages/Sections/CameraSecurity/SpecialDevices/Doorbells").then(
          (p) => ({ default: p.Doorbells }),
        ),
      ),
    },
  },
};
